import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { utils, write } from 'xlsx';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import { toast, ToastContainer } from 'react-toastify';
import useHandleErrors from '../../utils/user.utils';


const EmployeeManagement = () => {
    const [employees, setEmployees] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const storedToken = localStorage.getItem("token");
    const handleErrors = useHandleErrors();
    const [loading, setLoading] = useState(false);
    const hasFetchedRef = useRef(false);

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    const fetchEmployees = async () => {
        setLoading(true);
        try {
            const path = "/getEmployeeMasterReport";
            const URL = process.env.REACT_APP_BE_URL + path;
            const response = await axios.get(URL, {
                headers: {
                    Authorization: `Bearer ${storedToken}`,
                },
            });
            if (response.status === 200) {
                const allEmployees = [
                    ...response.data.onboardEmployeeDetails,
                    ...response.data.offboardEmployeeDetails
                ];
                setEmployees(allEmployees);
                setFilteredEmployees(allEmployees);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                console.error("Error fetching employee data:", error);
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchEmployees();
            hasFetchedRef.current = true;
        }
    }, []);

    useEffect(() => {
        // Filter employees based on the search query
        setFilteredEmployees(
            employees.filter(employee =>
                employee.EmployeeId.toLowerCase().includes(searchQuery.toLowerCase()) ||
                employee.FirstName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                employee.EmployeeType.toLowerCase().includes(searchQuery.toLowerCase()) ||
                employee.LastName.toLowerCase().includes(searchQuery.toLowerCase()) ||
                employee.OfficialEmail.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery, employees]);


    const sendEmail = (email) => {
        // Excel generation logic
        const ws = utils.json_to_sheet(filteredEmployees);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, 'Employees');
        const excelBuffer = write(wb, { bookType: 'xlsx', type: 'array' });

        // Convert the Excel file to a Base64 string
        const data = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const reader = new FileReader();
        reader.readAsDataURL(data);
        reader.onloadend = () => {
            const base64data = reader.result.split(',')[1]; // Get the Base64 string without the prefix

            // Create a downloadable link for the attachment
            const link = document.createElement('a');
            link.href = reader.result;
            link.download = 'EmployeeReport.xlsx';

            // Simulate a click to download the attachment
            link.click();

            // Prepare the mailto link (without attachment)
            const subject = "Employees List";
            const body = 'Please find the attached file.';
            const mailtoLink = `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

            toast.info('The Excel file has been generated and downloaded. Please attach the file manually to your email.', {
                position: toast.POSITION.TOP_CENTER,
            });

            setTimeout(() => {
                window.location.href = mailtoLink;
            }, 3000);

        };
    };

    const shareData = {
        title: 'Employees List',
        text: 'Check out the Employees list',
        url: window.location.href
    };

    const handleShare = async () => {
        try {
            await navigator.share(shareData);
        } catch (err) {
            console.error('Error sharing:', err);
        }
    };
    console.log("filteredEmployees", filteredEmployees);

    const exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredEmployees);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Employees");
        const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
        const today = new Date();
        const year = today.getFullYear().toString().slice(-2); // Get last two digits of the year
        const month = (today.getMonth() + 1).toString().padStart(2, '0'); // Add leading 0 for month
        const day = today.getDate().toString().padStart(2, '0'); // Add leading 0 for day
        const formattedDate = `${year}${month}${day}`;
        saveAs(blob, `WW360-Employees_Report_${formattedDate}.xlsx`);
    };

    //   pagaination code start

    const handleRecordsPerPageChange = (event) => {
        setRecordsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };

    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    const currentRecords = filteredEmployees.slice(indexOfFirstRecord, indexOfLastRecord);
    const totalPages = Math.ceil(filteredEmployees.length / recordsPerPage);


    const paginate = pageNumber => setCurrentPage(pageNumber);

    // end


    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div className="content-page">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col">
                            <h3 className="title mb-2">Employees</h3>
                        </div>
                        <div className="col-auto">
                            <a href={"/onboardemployee"} data-extra-toggle="tab" data-target="#employee-management-pan" className="btn btn-primary mt-lg-0 mt-4">
                                <i className="ri-user-add-line"></i> Onboard Employee
                            </a>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card mb-4">
                                <div className="card-body">
                                    <div className="row align-items-center justify-content-center">
                                        <div className="col-lg-5 col-md-8 col-sm-10">
                                            <div className="container-fluid row-rounded mb-0">
                                                <div className="row px-2 py-0">
                                                    <div className="input-group mb-0">
                                                        <input
                                                            type="search"
                                                            className="form-control search-input"
                                                            placeholder="Keyword search..."
                                                            value={searchQuery}
                                                            onChange={(e) => setSearchQuery(e.target.value)}
                                                        />
                                                        <div className="input-group-append">
                                                            <button className="btn btn-primary" type="button" title="Search" rel="tooltip">
                                                                <i className="ri-menu-search-line"></i>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <small className="form-text text-muted text-center mt-0">
                                                <i className="ri-information-2-fill text-info"></i> Allows: Employee ID - Email ID - First Name - Last Name
                                            </small>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col">
                                            <h5 className="title mt-1 mb-0">Summary</h5>
                                        </div>
                                        <div className="col-auto">
                                            <button
                                                type="button"
                                                title="Email"
                                                rel="tooltip"
                                                className="btn btn-light btn-circle ml-2"
                                                onClick={() => sendEmail('')}
                                            >
                                                <i className="ri-mail-send-fill"></i>
                                            </button>
                                            <button
                                                type="button"
                                                title="Share"
                                                rel="tooltip"
                                                className="btn btn-light btn-circle ml-2"
                                                onClick={handleShare}
                                            >
                                                <i className="ri-share-fill"></i>
                                            </button>
                                            <button type="button" title="Export" className="btn btn-light btn-circle ml-2" onClick={exportToExcel}>
                                                <i className="ri-export-fill"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-12">
                                            <div className="table-responsive leave-information">
                                                <table className="table grid">
                                                    <thead className="bg-light">
                                                        <tr>
                                                            <th>S.No.</th>
                                                            <th>ID  </th>
                                                            <th>First Name  </th>
                                                            <th>Last Name  </th>
                                                            <th>Emp Type  </th>
                                                            <th>Email ID  </th>
                                                            <th>Status </th>
                                                            <th></th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {currentRecords.map((employee, index) => (
                                                            <tr key={employee.id}>
                                                                <td>{index + 1 + indexOfFirstRecord}</td>
                                                                <td>{employee.EmployeeId}</td>
                                                                <td>{employee.FirstName}</td>
                                                                <td>{employee.LastName}</td>
                                                                <td>{employee.EmployeeType}</td>
                                                                <td>{employee.OfficialEmail}</td>
                                                                <td>
                                                                    {employee.Status.trim().toLowerCase() === 'active' ? (
                                                                        <span className="badge border border-success text-success status">
                                                                            <i className="ri-thumb-up-fill"></i> {employee.Status.trim()}
                                                                        </span>
                                                                    ) : employee.Status.trim().toLowerCase() === 'inactive' ? (
                                                                        <span className="badge border border-warning text-warning status">
                                                                            <i className="ri-thumb-down-line"></i> {employee.Status.trim()}
                                                                        </span>
                                                                    ) : employee.Status.trim().toLowerCase() === 'relieved' ? (
                                                                        <span className="badge border border-info text-info status">
                                                                            <i className="ri-user-follow-fill"></i> {employee.Status.trim()}
                                                                        </span>
                                                                    ) : employee.Status.trim().toLowerCase() === 'terminated' ? (
                                                                        <span className="badge border border-danger text-danger status">
                                                                            <i className="ri-close-fill"></i> {employee.Status.trim()}
                                                                        </span>
                                                                    ) : employee.Status.trim().toLowerCase() === 'onhold' ? (
                                                                        <span className="badge border border-primary text-primary status">
                                                                            <i className="ri-pause-circle-fill"></i> {employee.Status.trim()}
                                                                        </span>
                                                                    ) : employee.Status.trim().toLowerCase() === 'settled' ? (
                                                                        <span className="badge border border-secondary text-secondary status">
                                                                            <i className="ri-hand-coin-fill"></i> {employee.Status.trim()}
                                                                        </span>
                                                                    ) : (
                                                                        <span className="badge border border-light text-light status">
                                                                            <i className="ri-question-fill"></i> Unknown
                                                                        </span>
                                                                    )}
                                                                </td>
                                                                <td className="text-center">
                                                                    <span>
                                                                        <Link to={`/EmployeeDetails/${employee.EmployeeId}`} className="btn btn-link text-info btn-action" title="View" rel="tooltip">
                                                                            <i className="ri-eye-line"></i>
                                                                        </Link>
                                                                    </span>
                                                                    <span>
                                                                        <Link to={`/EmployeeUpdate/${employee.EmployeeId}`} className="btn btn-link text-info btn-action" title="Update" rel="tooltip">
                                                                            <i className="ri-list-settings-line"></i>
                                                                        </Link>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div className="col-md-12">
                                            <div className="container-fluid">
                                                <div className="row border-top pt-3">
                                                    <div className="col-auto">
                                                        <p className="mt-1 mb-0">Records</p>
                                                    </div>
                                                    <div className="col-1 record-drop">
                                                        <select className="form-control" value={recordsPerPage} onChange={handleRecordsPerPageChange}>
                                                            <option value="5">5</option>
                                                            <option value="10">10</option>
                                                            <option value="15">15</option>
                                                            <option value="20">20</option>
                                                            <option value="25">25</option>
                                                        </select>
                                                    </div>
                                                    <div className="col">
                                                        <nav>
                                                            <ul className="pagination justify-content-center">
                                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(1)} tabIndex="-1">
                                                                        <i className="ri-arrow-left-double-line"></i>
                                                                    </button>
                                                                </li>
                                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(currentPage - 1)} tabIndex="-1">
                                                                        <i className="ri-arrow-left-s-line"></i>
                                                                    </button>
                                                                </li>
                                                                {Array.from({ length: totalPages }, (_, index) => (
                                                                    <li key={index + 1} className={`page-item ${index + 1 === currentPage ? 'active' : ''}`}>
                                                                        <button className="page-link" onClick={() => paginate(index + 1)}>
                                                                            {index + 1}
                                                                        </button>
                                                                    </li>
                                                                ))}
                                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>
                                                                        <i className="ri-arrow-right-s-line"></i>
                                                                    </button>
                                                                </li>
                                                                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                                    <button className="page-link" onClick={() => paginate(totalPages)}>
                                                                        <i className="ri-arrow-right-double-fill"></i>
                                                                    </button>
                                                                </li>
                                                            </ul>
                                                        </nav>
                                                    </div>
                                                    <div className="col-auto">
                                                        <p className="mt-1 mb-0">Page Showing {currentPage} of {totalPages}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EmployeeManagement;


